import React, { useState } from "react";
import styled from "styled-components";
import Box from "react-raster";
import { H2, H3, Eyebrow, Copy } from "../Typography";
import Container from "../Container";

const Item = styled(Box)`
  border-top: 1px solid ${({ theme }) => theme.colours.lightGrey};
  padding: 30px 0;
`;

const Question = styled(H3)`
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 14px;
  font-weight: bold;
`;

const Answer = styled.div`
  max-height: ${({ isOpen }) => (isOpen ? "100vh" : 0)};
  overflow: hidden;
  transition: max-height 0.2s ease-in-out;
`;

const ToggleButton = styled.button`
  cursor: pointer;
  display: block;
  width: 100%;
  background: none;
  border: none;
  position: relative;
  padding: 0 50px 0 0;
  text-align: left;
  margin: 0;
`;

export const CaretSvg = styled.svg`
  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : undefined)};
  transition: transform 0.2s ease-in-out;
  position: absolute;
  top: 0;
  right: 0;
`;

const FullWidthWrapper = styled.div`
  width: 100%;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
`;

export function ToggleCaret({ isOpen }) {
  return (
    <CaretSvg
      isOpen={isOpen}
      width="30"
      height="17"
      viewBox="0 0 30 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M29 1L15 15L1 1" stroke="black" strokeWidth="2" />
    </CaretSvg>
  );
}

function FAQs({ questions, title, hasBottomMargin, hasTopMargin }) {
  const [openQuestions, setOpenQuestions] = useState(new Set());
  const updateOpenQuestions = (i) => {
    const newOpenQuestions = new Set(openQuestions);
    if (openQuestions.has(i)) {
      newOpenQuestions.delete(i);
    } else {
      newOpenQuestions.add(i);
    }

    setOpenQuestions(newOpenQuestions);
  };

  return (
    <FullWidthWrapper
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <Container gridRowGap={0}>
        <Box cols={[6, 10]} marginLeft={[0, 1]} marginBottom={0.3}>
          <H2>{title}</H2>
        </Box>
        {questions.map((question, i) => (
          <Item
            itemScope
            itemProp="mainEntity"
            itemType="https://schema.org/Question"
            cols={[6, 10]}
            marginLeft={[0, 1]}
            key={question.id}
          >
            <Eyebrow colour="blue">{i < 10 ? `0${i}` : i}</Eyebrow>
            <ToggleButton type="button" onClick={() => updateOpenQuestions(i)}>
              <Question itemProp="name" animated={false}>
                {question.question}
              </Question>
              <ToggleCaret isOpen={openQuestions.has(i)} />
            </ToggleButton>
            <Answer
              itemScope
              itemProp="acceptedAnswer"
              itemType="https://schema.org/Answer"
              isOpen={openQuestions.has(i)}
            >
              <Copy itemProp="text">{question.answer}</Copy>
            </Answer>
          </Item>
        ))}
      </Container>
    </FullWidthWrapper>
  );
}

export default FAQs;
